import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { BackIcon, CrossIcon } from '../../Svg/Index.js'
import { SET_TYPE, SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { REFUSE_REQUEST, ACCEPT_REQUEST, REMOVE_FRIEND, REVOKE_REQUEST } from '../../Actions/User'

class FriendsOverview extends Component {

    state = {
        dialogActive: false,
        remove_friend_id: null,
    }

    changeType = (type) => {
        this.props.actions.SET_TYPE(type)
    }

    handleDelete(id) {
        this.props.actions.REFUSE_REQUEST(id).then(res => {
        })
    }

    handleAccept(id) {
        this.props.actions.ACCEPT_REQUEST(id).then(res => {
        })
    }

    handleRevokeRequest = (id) => {
        this.props.actions.REVOKE_REQUEST(id)
    }

    handleRefuseRequest = (id) => {
        this.props.actions.REFUSE_REQUEST(id)
    }

    handleFriendRemove = ()=> {
        this.props.actions.REMOVE_FRIEND(this.state.remove_friend_id).then(res => {
            this.setState({dialogActive: false})
        })
    }

    showProfile = (e, userId) => {
        if(e.target.classList.contains('c-btn')) return;
        this.props.actions.SET_PROFILE_OPEN(userId);
    }

    render() {
        const { friends, friend_requests, sent_friend_requests } = this.props.user
        const { dialogActive } = this.state
        return (
            <div className="c-sidebar-overlay">
                <div className="c-sidebar-overlay__inner">
                    <button className="c-btn c-btn--back" onClick={ () => this.changeType('') }>
                        <BackIcon />
                    </button>

                    {
                        friend_requests.length > 0 && (
                            <>
                                <h2 className="c-sidebar-overlay__title">Vriendschapsverzoeken</h2>
                                <ul className="c-list">
                                    {
                                        friend_requests.map((item, i) => 
                                            item.user && (
                                                <li className="c-list__item" onClick={(e) => this.showProfile(e, item.user._id)} key={`user-${item._id}}`}>
                                                    <div className="c-list-user">
                                                        <div className="c-list-avatar" style={{backgroundImage: `url(${item.user.avatar.user_avatar})`}}>
                                                        </div>
                                                        <span className="c-list-user__name">{item.user.display_name}</span>
                                                        <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={ () => this.handleAccept(item._id) }>Bevestigen</button>
                                                        <button className="c-btn c-bare-btn c-btn--cancel" onClick={ () => this.handleRefuseRequest(item._id) }>
                                                            <CrossIcon />
                                                        </button>
                                                    </div>
                                                </li>
                                            )
                                        )
                                    }        
                                </ul>
                            </>
                        )
                    }

                    {
                        sent_friend_requests.length > 0 && (
                            <>
                                <h2 className="c-sidebar-overlay__title">Afwachtend</h2>
                                <ul className="c-list">
                                    {
                                        sent_friend_requests.map((item, i) => 
                                            item.friend && (
                                                <li className="c-list__item" onClick={(e) => this.showProfile(e, item.friend._id)} key={`request-${item._id}}`}>
                                                    <div className="c-list-user">
                                                        <div className="c-list-avatar" style={{backgroundImage: `url(${item.friend.avatar.user_avatar})`}}>
                                                        </div>
                                                        <span className="c-list-user__name">{item.friend.display_name}</span>
                                                        <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={ () => this.handleRevokeRequest(item._id) }>Annuleren</button>
                                                    </div>
                                                </li>
                                            )
                                        )
                                    }
                                </ul>
                            </>
                        )
                    }

                    {
                        friends.length > 0 && (
                            <>
                                <h2 className="c-sidebar-overlay__title">Vrienden</h2>
                                <ul className="c-list">
                                    {
                                        friends.map((item, i) => 
                                            <li className="c-list__item" onClick={(e) => this.showProfile(e, item._id)}  key={`user-${item._id}}`}>
                                                <div className="c-list-user">
                                                    <div className="c-list-avatar" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                                    </div>
                                                    <span className="c-list-user__name">{item.display_name}</span>
                                                    <button className="c-btn c-bare-btn c-btn--cancel" onClick={ () => this.setState({dialogActive: true, remove_friend_id: item._id}) }>
                                                        <CrossIcon />
                                                    </button>
                                                </div>
                                            </li>
                                        )
                                    }        
                                </ul>
                            </>
                        )
                    }

                    {
                        friends.length === 0 && (
                            <h2 className="c-sidebar-overlay__title">Je hebt nog geen vrienden</h2>
                        )
                    }
                    

                </div>

                {
                    dialogActive && (
                        <div className="c-dialog">
                            <div className="c-dialog__inner">
                                <h2>Weet je het zeker?</h2>
                                <button className="c-btn c-btn--primary" onClick={this.handleFriendRemove}>Ja, verwijder</button>
                                <button className="c-btn c-btn--primary" onClick={ () => this.setState({dialogActive: false}) }>Nee, annuleren</button>
                            </div>
                        </div>
                    )
                }

            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({SET_TYPE, REFUSE_REQUEST, ACCEPT_REQUEST, REMOVE_FRIEND, REVOKE_REQUEST, SET_PROFILE_OPEN}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FriendsOverview)